// transformation map from form option to value in database
export const ValueMap = {
  PCList: {
    "壞球": 'Ball',
    "好球(揮空)": 'Strk-S',
    "好球(沒揮)": 'Strk-C', 
    "界外": 'Foul',
    "擊進場內": 'In-Play',
  },
  HTList: {
    "滾地球": 'GROUND', 
    "平擊球": 'LINE',
    "高飛球": 'FLYB',
    "內野飛球": 'POPB',
  },
  PRList: {
    "三振": "SO",
    "四壞球": "BB",
    "觸身球": "HBP",
    "一壘安打": '1B',
    "二壘安打": '2B',
    "三壘安打": '3B',
    "全壘打": 'HR',
    "飛球出局": 'FO',
    "滾地球出局": 'GO',
    "雙殺打": 'DP',
    "三殺打": 'TP',
    "失誤": 'E',
    "犧飛(含失誤)": 'SF',
    "犧觸(含失誤)": 'SH',
    "出局": 'OUT',
  },
  OList: {
    "無人出局": 0,
    "一人出局": 1,
    "二人出局": 2
  },
  OBList: {
    "得點圈有人": 0,
    1: 1,
    2: 2,
    3: 4,
  },
  HardTList: {
    "強勁": 'HARD',
    "一般": 'MED',
    "軟弱": 'SOFT'
  },
  BarrelList: {
    "Barrels": "Barrels",
    "Solid Contact": "Solid_Contact",
    "Flares & Bumers": "Flares_Bumers",
    "Topped": "Topped",
    "Hit Under": "Hit_Under",
    "Weak Contact": "Weak_Contact"
  },
  ZPointList: {
    "內角球": 'Right',
    "中間球": 'H_Med',
    "外角球": 'Left',
    "高球": 'High',
    "中球": 'V_Med',
    "低球": 'Low'
  },
  TagPList: {
    "四縫FB": 'FB',
    "伸卡FT": 'FT',
    "快速指叉SFF": 'SFF',
    "滑球SL": 'SL',
    "曲球CB": 'CB',
    "卡特CT": 'CT',
    "變速CH": 'CH',
    "指叉SP": 'SP',
    "慢速曲球SC": 'SC',
    "蝴蝶KN": 'KN',
    "其他OT": 'OT'
  }
}

export const TaggedPitchTypeLabelMap = {
  "all": "全部",
  "FB": "四縫",
  "FT": "伸卡",
  "CT": "卡特",
  "SL": "滑球",
  "CB": "曲球",
  "SC": "慢速曲球",
  "CH": "變速球",
  "SP": "指叉球",
  "SFF": "快速指叉",
  "OT": "其他",
  "UN": "未知",
  "KN": "蝴蝶球",
  "?": "?",
  "": "N/A",
  null: "IBB",
  "ALFB": "直球"
}

// range of given game no in database, format: [upper_bound], [lower_bound, upper_bound]
export const GameNoRange = {
  '一軍例行賽': [1000], 
  '二軍例行賽': [5000, 10000], 
  '季前熱身賽': [4000, 5000], 
  '所有賽事': [10000]
}